import {
  USER_LOGOUT,
  USER_LOGOUT_SUCCESS_RESET,
  SET_SUSPENDED_USER_FLAG,
} from "redux/constants/portal";

export const userLogout = (tenant_id, auth0_id) => ({
  type: USER_LOGOUT,
  payload: { tenant_id, auth0_id },
});
export const userLogoutSuccessReset = () => ({
  type: USER_LOGOUT_SUCCESS_RESET,
});
export const setSuspendedUserFlag = (payload) => ({
  type: SET_SUSPENDED_USER_FLAG,
  payload,
});